/* / eslint-disable react-hooks/exhaustive-deps / */
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { baseUrlImg } from '../../../Api';
import * as S from './style';
import CustomDropdown from '../../CustomDropDown'
import { MegaMenuPanel } from '../MegaMenu';

const DROPDOWN_CLOSE_DELAY = 150;

export const MenuDesktop = ({
  menu,
  setMenu,
  optionsMenu,
  data,
  logoCopasul,
}) => {
  const closeTimeoutRef = useRef(null);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isMenuActive = (item) => {
    const routes = [
      item?.menu?.rota,
      ...(item?.menu?.subMenu?.map((sub) => sub?.rotaSubmenu) ?? []),
    ].filter((route) => route && route !== '/' && route.indexOf('http') === -1);

    return routes.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`),
    );
  };

  // A cada navegação, fecha os submenus abertos. A forma com função lê o menu
  // atual sem depender dele (senão o efeito rodaria a cada mudança do menu).
  useEffect(() => {
    setMenu((atual) => {
      const updateMenu = [...atual];
      updateMenu.forEach((item) => {
        item.status = false;
      });
      return updateMenu;
    });
  }, [navigate, setMenu]);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  const activeItem = menu.find((item) => item.status);

  const cancelCloseDropdown = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const openDropdown = (index) => {
    cancelCloseDropdown();

    const updateMenu = [...menu];
    updateMenu.forEach((item, i) => {
      item.status = i === index;
    });
    setMenu(updateMenu);
  };

  const scheduleCloseDropdown = () => {
    closeTimeoutRef.current = setTimeout(() => {
      const updateMenu = [...menu];
      updateMenu.forEach((item) => {
        item.status = false;
      });
      setMenu(updateMenu);
    }, DROPDOWN_CLOSE_DELAY);
  };

  const handleTopLevelClick = (item) => {
    // Itens com submenu servem apenas para abrir o dropdown (hover); a
    // navegação acontece pelos cards internos, não pelo botão de topo.
    if (item?.menu?.subMenu?.length > 0) return;

    const route = item?.menu?.rota;
    if (!route) return;

    if (route.indexOf('http') !== -1) {
      window.open(route, '_blank');
      return;
    }

    navigate(route);
  };

  return (
    <S.HeaderBox>
      <S.HeaderRow>
        <button>
          {logoCopasul && (
            <S.LogoImg
              src={`${baseUrlImg}${logoCopasul}`}
              alt="Logo copasul"
              onClick={() => navigate('/')}
            />
          )}
        </button>

        <S.SecondNav>
          {menu.length > 0 && (
            /* O Início também vai no MenuItem, senão a área de hover dele fica
               do tamanho da palavra enquanto os outros pegam o bloco todo. */
            <S.MenuItem>
              <S.HomeLink to="/" end>
                Início
              </S.HomeLink>
            </S.MenuItem>
          )}
          {menu.map((item, index) => (
            <S.MenuItem
              key={index}
              onMouseEnter={() => openDropdown(index)}
              onMouseLeave={scheduleCloseDropdown}
            >
              <S.MenuButton
                $active={isMenuActive(item)}
                onClick={() => handleTopLevelClick(item)}
              >
                <p>{item?.menu?.tituloMenu}</p>
              </S.MenuButton>
            </S.MenuItem>
          ))}
        </S.SecondNav>

        <S.ButtonsBox>
          {data?.botoes[0]?.linkBotao?.linkExterno && (
            <S.ButtonTransparent
              onClick={() => {
                window.open(
                  `${data?.botoes[0]?.linkBotao?.linkExterno}`,
                  '_blank',
                );
              }}
            >
              <User />
              <span>{data?.botoes[0]?.linkBotao?.tituloLink}</span>
            </S.ButtonTransparent>
          )}
          {data?.botoes[1]?.linkBotao?.linkExterno && (
            <S.ButtonBackground
              onClick={() => {
                window.open(
                  `${data?.botoes[1]?.linkBotao?.linkExterno}`,
                  '_blank',
                );
              }}
            >
              {data?.botoes[1]?.linkBotao?.tituloLink}
            </S.ButtonBackground>
          )}

          <S.SearchBox>
            <CustomDropdown optionsMenu={optionsMenu} onSelect={(route) => window.location.href = route} />
          </S.SearchBox>
        </S.ButtonsBox>

        {activeItem?.menu?.subMenu?.length > 0 && (
          <S.DropdownWrapper
            onMouseEnter={cancelCloseDropdown}
            onMouseLeave={scheduleCloseDropdown}
          >
            <MegaMenuPanel items={activeItem.menu.subMenu} />
          </S.DropdownWrapper>
        )}
      </S.HeaderRow>
      <S.HeaderAccent />
    </S.HeaderBox>
  );
};
